import Grid, { GridSize, GridSpacing } from "@material-ui/core/Grid";
import { Variant } from "@material-ui/core/styles/createTypography";
import { ObjectFieldTemplateProps } from "@rjsf/core";
import React from "react";
import { Description, Title } from "../shared";

interface ObjectFieldTemplateOptions {
  title?: {
    variant?: Variant | "label";
    margin?: "normal" | "none";
  };
  layout?: {
    spacing?: GridSpacing;
    size?: {
      xs?: GridSize;
      sm?: GridSize;
      md?: GridSize;
      lg?: GridSize;
      xl?: GridSize;
    };
  };
}

export const ObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  const { idSchema, uiSchema, title, description, properties } = props;

  const uiOptions = uiSchema["ui:options"] as ObjectFieldTemplateOptions | undefined;

  const titleMargin = uiOptions?.title?.margin;
  const titleVariant = uiOptions?.title?.variant;

  const gridSpacing = uiOptions?.layout?.spacing ?? 2;

  const gridSizeXs = uiOptions?.layout?.size?.xs ?? 12;
  const gridSizeSm = uiOptions?.layout?.size?.sm;
  const gridSizeMd = uiOptions?.layout?.size?.md;
  const gridSizeLg = uiOptions?.layout?.size?.lg;
  const gridSizeXl = uiOptions?.layout?.size?.xl;

  return (
    <>
      {title && <Title fieldId={`${idSchema.$id}_title`} title={title} margin={titleMargin} variant={titleVariant} />}
      {description && <Description fieldId={`${idSchema.$id}_description`} description={description} />}
      <Grid container={true} spacing={gridSpacing} className="properties">
        {properties
          .filter(property => property.content.props.uiSchema?.["ui:widget"] !== "hidden")
          .map((property, index) => {
            // TitleWidget is not sizable (i.e. takes up full-width)
            const isGridSizable = property.content.props.uiSchema?.["ui:widget"] !== "TitleWidget";
            return (
              <Grid
                key={`property_${index}`}
                item={true}
                xs={isGridSizable ? gridSizeXs : 12}
                sm={isGridSizable ? gridSizeSm : undefined}
                md={isGridSizable ? gridSizeMd : undefined}
                lg={isGridSizable ? gridSizeLg : undefined}
                xl={isGridSizable ? gridSizeXl : undefined}
                className="property"
              >
                {property.content}
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};
